export const SET_ASSIGNED_STAKEHOLDERS = "SET_ASSIGNED_STAKEHOLDERS";
export const SET_STAKEHOLDERS = "SET_STAKEHOLDERS";
export const SET_MATURITY_SURVEY = "SET_MATURITY_SURVEY";
export const SET_MATURITY_SURVEY_ID = "SET_MATURITY_SURVEY_ID";
export const SET_ESG_MATURITY_SCORE = "SET_ESG_MATURITY_SCORE";
export const SET_MATURITY_ASSESSMENT_DETAILS =
  "SET_MATURITY_ASSESSMENT_DETAILS";
